import EventsForm from '../../features/Events/EventsForm/EventsForm';
import EventsSearchResult from './EventsSearchResult';
import React, { useEffect, useState } from 'react';
import { i18n } from '../../services/i18n';
import { Segment } from 'semantic-ui-react';
import { useTrips } from '../../store/hooks/useTrips/useTrips';
import './styles.scss';

const EventsPage: React.FC = () => {
  const [{ isLoading: isTripsLoading }, { handleResetTrips }] = useTrips();
  const [isSearched, setIsSearched] = useState(false);

  useEffect(() => {
    if (isTripsLoading) {
      setIsSearched(true);
    }
  }, [isTripsLoading]);

  useEffect(() => {
    return () => {
      handleResetTrips();
    };
  }, [handleResetTrips]);

  return (
    <>
      <Segment>
        <div className="page-title">
          <h2>{i18n('Events_Link')}</h2>
        </div>
        <div className="page-body-container">
          <EventsForm onClear={() => setIsSearched(false)} />
        </div>
      </Segment>

      {isSearched && <EventsSearchResult />}
    </>
  );
};

export default EventsPage;
